<template>
  <div class="statistic">
    <div class="statistic__title">
      {{$t('feed.connections.title')}}
    </div>

    <el-card shadow="hover" class="statistic__card" v-loading="pending">
      <network
        class="network"
        ref="network"
        :nodes="network.nodes"
        :edges="network.edges"
        :options="network.options"
        @doubleClick="networkEvent"
        @selectNode="showAllNodes">
      </network>
    </el-card>
  </div>
</template>

<script>
  /*relations component from tabs directory of analytics*/

  // chart
  import { Network } from 'vue2vis';

  import { getAnalyticsApi } from "../../../../../../api/stats";

  export default {
    name: "Connections",
    props: {
      active: {
        type: Boolean
      }
    },
    data() {
      return {
        pending: false,
        network: {
          nodes: [
            { id: 17950899, label: 'Загрузка...' },
            { id: 17100899, label: 'Загрузка...' },
            { id: 20950899, label: 'Загрузка...' },
          ],
          edges: [
            { id: 1, from: 17950899, to: 17100899 },
            { id: 2, from: 17100899, to: 17950899 },
            { id: 3, from: 20950899, to: 17950899 },
          ],
          options: {
            nodes: {
              shape: 'square',
              borderWidth: 2,
              font: {
                size: 14,
                strokeWidth: 0
              },
            },
            edges: {
              smooth: {
                type: 'continuous',
              },
            },
            physics: {
              forceAtlas2Based: {
                gravitationalConstant: -30,
                centralGravity: 0.005,
                springLength: 100,
                springConstant: 0.05
              },
              maxVelocity: 70,
              solver: 'forceAtlas2Based',
              timestep: 1,
              stabilization: {
                enabled: false,
              }
            },
          },
        },
        networkEvents:'',
        nodes: '',
        moreThenTwoConnections: [],
        slave: [],
        leading: [],
      };
    },
    /*mounted: function() {
      this.load_nodes()
        .then(() => {
          this.opentNodes();
        });
    },*/
    computed: {
      leadingNodesComputed() {
        let nodes = [];
        for (let i = 0; i < this.leading.length; i++) {
          let image = this.leading[i].image || 'http://';
          nodes.push({
            'id': this.leading[i].id,
            shape: 'image',
            image: image,
            size: 100,
            label: this.leading[i].name,
            margin: { top: 10, right: 20, bottom: 40, left: 30 }
          });
        };
        return nodes;
      },
      slaveNodesComputed() {
        let nodes = [];
        return nodes;
      },
      connectionToOneNode() {},
      connectionMoreThenOneNode() {},
    },
    methods: {
      // clusteringNodes() {
      //   let leadingId = this.leading.map(lead => lead.id);
      //   // console.log(leadingId);
      //   leadingId.forEach(lead => this.$refs.network.clusterByConnection(lead))
      // },
      getRandomColor(i) {
        let colors = [
          '#4CAF50',
          '#607D8B',
          '#FB8C00',
          '#AD1457',
          '#03A9F4',
          '#795548',
          '#FF5722',
          '#FFB300',
          '#FFEE58',
          '#CDDC39',
          '#1B5E20',
          '#212121',
          '#5D4037',
          '#263238',
          '#03A9F4',
          '#1A237E',
          '#AB47BC',
          '#C2185B',
          '#d50000',
          '#D500F9',
          '#2979FF'
        ];

        if (colors[i]) {
          return colors[i];
        } else {
          let letters = '0123456789ABCDEF';
          let color = '#';
          for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          return color;
        }
      },
      showAllNodes(data) {
        if (data.nodes.length === 1) {
          // console.log(this.$refs.network.isCluster(data.nodes[0]));
          // if (this.$refs.network.isCluster(data.nodes[0]) == true) {
          //   this.$refs.network.openCluster(data.nodes[0]);
          // } else {
          for (let i = 0; this.network.nodes.length > i; i++) {
            if (data.edges.includes(this.network.nodes[i].id * 100000)) {
              this.network.nodes[i].hidden ? this.network.nodes[i].hidden = false :
                this.network.nodes[i].hidden = true;
            }
          }
          this.openNodes(data);
          // }
        }
      },
      openNodes(data) {
       /* let id = null;
        if (data) {
          id = data.nodes[0];
        }*/
        this.network.nodes.forEach((node) => {
          /*if (id) {
            node.to = id;
          }*/
          // if (data.edges.includes(node.id * 100000) || data.edges.includes(node.id * 100000 + 1)) {
          if (this.moreThenTwoConnections.includes(node.id)) {
            node.hidden = false;
          }
          // }
        })
      },
      openInNewTab(url) {
        let win = window.open(url, '_blank');
        win.focus();
      },
      networkEvent(data) {
        let id = Math.floor(data.edges[0]);
        let pop = data.nodes[0];
        if (pop) {
          id = pop;
        }

        if (isNaN(id)) {
          return;
        }

        if (id < 0) {
          id = 'public' + id;
        } else {
          id = 'id' + id;
        }

        this.networkEvents = data.event.type;

        /*if (this.networkEvents ===  'doubletap') {

          let nodeId = Number(id.replace('id', ''));

          this.network.nodes = this.network.nodes.map(item => {
            if (item.id === nodeId || item.to === nodeId) {
              item.hidden = true
            }

            return item;
          });

          this.network.edges = this.network.edges.map(item => {
            if (item.to === nodeId) {
              item.hidden = true;
            }

            return item;
          });

          this.openInNewTab(`http://vk.com/${id}`);
        }*/
      },
      load_nodes() {
        this.pending = true;

        let params = {
          thread_id: this.$route.params.threadId,
          start:0,
          limit: 10000,
        };

        getAnalyticsApi(params).then(resp => {
          let leading = resp.data.leading;
          let slave = resp.data.slave;

          this.slave = slave;
          this.leading = leading;

          this.network.nodes = [];
          this.network.links = [];
          this.network.edges = [];

          let group = 0;
          let size = 100;

          for(let i = 0; i < leading.length; i++) {

            group = i;
            let image = leading[i].image || 'http://';
            this.network.nodes.push({
              'id': leading[i].id,
              shape: 'image',
              image: image,
              size: 85,
              label: ' '+leading[i].name+' ',
              font: {
                background: '#4CAF50',
                size: 20,
              },
              color: this.getRandomColor(i),
              hidden: false
            });
            this.moreThenTwoConnections.push(leading[i].id);

            size = size - 5;
            size = Math.max(size,10);
          }

          group++;

          let cut = [];

          for (let i = 0;i < slave.length; i++) {
            let image = slave[i].image || 'http://';
            if (!cut[slave[i].connections[0].id]) {
              cut[slave[i].connections[0].id] = 0;
            }

            cut[slave[i].connections[0].id] += 1;
            if(cut[slave[i].connections[0].id] < 200) {
              this.network.nodes.push({
                'id': slave[i].id,
                shape: 'image',
                image: image,
                size: 15,
                label: ' '+slave[i].name+' ',
                // mass: ((100 - slave[i].weight) / 50) + 1,
                hidden: true,
              })
            }
          }


          for (let i = 0; i < slave.length; i++) {
            for (let j = 0; j < slave[i].connections.length; j++) {
              this.network.edges.push({
                id: slave[i].id * 100000 + j,
                from: slave[i].id,
                to: slave[i].connections[j].id,
                color: {inherit: 'to'},
                hidden: false,
              })
            }
            if (slave[i].connections.length > 1) {this.moreThenTwoConnections.push(slave[i].id)}
          }
          this.pending = false;
          this.openNodes();
        });
      },
    },
    components: {
      Network,
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.slave.length) {
            this.load_nodes();
          }
        }
      }
    },
  };
</script>

<style>
  .statistic__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .statistic__card {
    margin-bottom: 20px;
  }
  .network {
    height: 600px;
  }
</style>
